var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChina = function SvgChina(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#china_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m7.662 8.52 1.208 3.72h3.91l-3.16 2.302 1.208 3.718-3.166-2.297-3.167 2.297 1.214-3.718-3.166-2.303h3.91zM16.598 21.684l-.924-1.138-1.368.53.793-1.23-.924-1.143 1.416.378.799-1.23.076 1.465 1.422.377-1.372.525zM18.435 18.348l.438-1.4-1.198-.848 1.466-.022.432-1.4.476 1.39 1.465-.017-1.176.875.47 1.389-1.197-.848zM20.913 10.276l-.646 1.318 1.05 1.023-1.45-.208-.644 1.312-.252-1.443-1.455-.208 1.302-.684-.252-1.449 1.05 1.023zM16.636 6.284l-.11 1.46 1.362.552-1.427.35-.104 1.466-.771-1.247-1.427.35.946-1.121-.777-1.242 1.362.553z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "china_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgChina;